module.exports = __webpack_public_path__ + "static/media/mealhada-pampilhosa-1.16197c52.jpg";